module.exports = {"id":"176483","name":"Dmytro Chygrynskyi","rating":"76","photo":"./data/images/photos/3/176483.png","club":{"name":"AEK Athènes","logo":"./data/images/clubs/AEKAthenes.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DmytroChygrynskyi0.json
// module id = 1123
// module chunks = 0